export const MAX_CONTENT_KEYWORD_COUNT = 10;
export const MAX_CONTENT_KEYWORD_LENGTH = 6;
export const CONTENT_LIST_PAGE_ITEM_COUNT = 20;
export const MAX_CONTENT_TITLE_LENGTH = 100;
export const NEW_CONTENT_TIME = 7 * 24 * 60 * 60 * 1000;
export const UP_CONTENT_TIME = 2 * 24 * 60 * 60 * 1000;

export enum ContentFilterType {
  All = 'All',
  New = 'New',
  UpcomingHidden = 'UpcomingHidden',
  Exclusive = 'Exclusive',
  Completed = 'Completed',
  Published = 'Published',
}

export enum ContentOrderType {
  Id = 'Id',
  LatestCreatedAt = 'LatestCreatedAt', // TODO Deprecated
  LatestFirstOpenedAt = 'LatestFirstOpenedAt',
  LatestEpisodeOpenedAt = 'LatestEpisodeOpenedAt',
  UpcomingHidden = 'UpcomingHidden',
  FavoriteCount = 'FavoriteCount',
  Best = 'Best',
}
export const ContentOrderTypeListString = {
  [ContentOrderType.Id]: '등록순',
  [ContentOrderType.LatestCreatedAt]: '최근 생성순',
  [ContentOrderType.LatestFirstOpenedAt]: '최신순',
  [ContentOrderType.LatestEpisodeOpenedAt]: '업데이트순',
  [ContentOrderType.UpcomingHidden]: '숨기기 임박순',
  [ContentOrderType.FavoriteCount]: '좋아요순',
  [ContentOrderType.Best]: '인기순',
};

export const HomeContentOrderTypeList = [
  ContentOrderType.LatestCreatedAt,
  ContentOrderType.LatestFirstOpenedAt,
  ContentOrderType.LatestEpisodeOpenedAt,
];

export const ContentOrderTypeList = [
  ContentOrderType.LatestCreatedAt,
  ContentOrderType.LatestFirstOpenedAt,
  ContentOrderType.LatestEpisodeOpenedAt,
  ContentOrderType.UpcomingHidden,
];

export const ContentOrderTypeOptions = ContentOrderTypeList.map(it => ({
  label: ContentOrderTypeListString[it],
  id: it,
  value: it,
}));

export enum RelayType {
  Private = 'Private',
  Public = 'Public',
  Deleted = 'Deleted',
}

export enum ContentStatus {
  Private = 'Private',
  Public = 'Public',
}

export const ContentStatusList = [ContentStatus.Public, ContentStatus.Private];
export const ContentStatusString = {
  [ContentStatus.Public]: '공개',
  [ContentStatus.Private]: '비공개',
};

export enum ContentSerializeStatus {
  All = 'All',
  Serialized = 'Serialized',
  Completed = 'Completed',
  Published = 'Published',
}

export const ContentSerializeStatusString = {
  [ContentSerializeStatus.All]: '전체',
  [ContentSerializeStatus.Serialized]: '연재 중',
  [ContentSerializeStatus.Completed]: '완결',
  [ContentSerializeStatus.Published]: '출간',
};

export enum ContentImageType {
  Cover = 'Cover',
}

export const ContentImageTypeList = [ContentImageType.Cover];
export const ContentImageTypeString = {
  [ContentImageType.Cover]: '커버',
};

export enum AgeRestriction {
  All = 'All',
  Fifteen = 'Fifteen',
  Adult = 'Adult',
}

export enum DirittoExclusiveType {
  None = 'None',
  DirittoOriginal = 'DirittoOriginal',
  DirittoOnly = 'DirittoOnly',
}
export const DirittoExclusiveTypeString = {
  [DirittoExclusiveType.None]: '--',
  [DirittoExclusiveType.DirittoOriginal]: '디리토 오리지널',
  [DirittoExclusiveType.DirittoOnly]: '디리토 Only',
};

export const AgeRestrictionList = [AgeRestriction.All, AgeRestriction.Fifteen, AgeRestriction.Adult];
export const AgeRestrictionNonAdultList = [AgeRestriction.All, AgeRestriction.Fifteen];
export const AgeRestrictionString = {
  [AgeRestriction.All]: '전체 이용가',
  [AgeRestriction.Fifteen]: '15세 이상',
  [AgeRestriction.Adult]: '성인',
};

export enum UsageType {
  Using = 'Using',
  NotUsing = 'NotUsing',
}
export const UsageTypeList = [UsageType.Using, UsageType.NotUsing];
export const UsageTypeString = {
  [UsageType.Using]: '사용',
  [UsageType.NotUsing]: '사용하지 않음',
};

export enum CategoryType {
  All = 'All',
  RomanceFantasy = 'RomanceFantasy',
  Romance = 'Romance',
  BL = 'BL',
  Fantasy = 'Fantasy',
  Any = 'Any',
  FanFiction = 'FanFiction',
}

export enum KeywordType {
  Normal = 'Normal',
  Operation = 'Operation',
  PickAndChoo2 = 'PickAndChoo2', // deprecated
  PickAndChoo2Subcategory = 'PickAndChoo2Subcategory', // deprecated
  Contest = 'Contest',
}

export const CategoryTypeList = [
  CategoryType.Fantasy,
  CategoryType.BL,
  CategoryType.RomanceFantasy,
  CategoryType.Romance,
  CategoryType.Any,
];

export const CategoryTypeFilterList = [
  CategoryType.All,
  CategoryType.Fantasy,
  CategoryType.BL,
  CategoryType.RomanceFantasy,
  CategoryType.Romance,
  CategoryType.Any,
];

export const CategoryTypeId = {
  [CategoryType.All]: 0,
  [CategoryType.RomanceFantasy]: 1,
  [CategoryType.Romance]: 2,
  [CategoryType.BL]: 3,
  [CategoryType.Fantasy]: 4,
  [CategoryType.Any]: 5,
  [CategoryType.FanFiction]: 6,
};

export const CategoryTypeById = {
  [CategoryTypeId[CategoryType.RomanceFantasy]]: CategoryType.RomanceFantasy,
  [CategoryTypeId[CategoryType.Romance]]: CategoryType.Romance,
  [CategoryTypeId[CategoryType.BL]]: CategoryType.BL,
  [CategoryTypeId[CategoryType.Fantasy]]: CategoryType.Fantasy,
  [CategoryTypeId[CategoryType.Any]]: CategoryType.Any,
  [CategoryTypeId[CategoryType.FanFiction]]: CategoryType.FanFiction,
};

export const CategoryTypeString = {
  [CategoryType.All]: '전체',
  [CategoryType.RomanceFantasy]: '로판',
  [CategoryType.Romance]: '로맨스',
  [CategoryType.BL]: 'BL',
  [CategoryType.Fantasy]: '판타지',
  [CategoryType.Any]: '자유',
  [CategoryType.FanFiction]: '팬픽',
};

export enum ReplyAllow {
  Allow = 'Allow',
  Deny = 'Deny',
}

export const ReplyAllowList = [ReplyAllow.Allow, ReplyAllow.Deny];

export const ReplyAllowString = {
  [ReplyAllow.Allow]: '허용',
  [ReplyAllow.Deny]: '허용 안함',
};

export enum ContentDetailTabType {
  Episode = 'Episode',
  Reply = 'Reply',
  FancyShare = 'FancyShare',
  Rolling = 'Rolling',
}

export enum WsContentDetailTabType {
  Series = 'Series',
  Reserved = 'Reserved',
  Saved = 'Saved',
}

export const WsContentDetailTabList = [
  { name: '회차', value: WsContentDetailTabType.Series },
  { name: '예약', value: WsContentDetailTabType.Reserved },
  { name: '저장', value: WsContentDetailTabType.Saved },
];

export enum StudioContentsTabType {
  Serialized = 'Serialized',
  CompletedOrPublished = 'CompletedOrPublished',
  All = 'All',
  Contest = 'Contest',
}

export enum StudioContentEpisodesTabType {
  Episode = 'Episode',
  Notice = 'Notice',
}

export enum StudioContentEpisodesStatusTabType {
  Public = 'Public',
  Reserved = 'Reserved',
  Saved = 'Saved',
}

export const CategoryTypeOptionList = [CategoryType.All, ...CategoryTypeList];
export const CategoryTypeOptionString = {
  ...CategoryTypeString,
  [CategoryType.All]: '전체',
};

export const CategoryTypeOptions = CategoryTypeOptionList.map(it => ({
  label: CategoryTypeOptionString[it],
  id: it,
  value: it,
}));

export const DisplayReservedHideContentsDiffDays = 10;

export const DisplayNewContentDiffDays = 30;

export enum ContentKeywordAssignedBy {
  Author = 'Author',
  Operator = 'Operator',
  Contest = 'Contest',
}

export enum DirittoKeyword {
  Contest2023Winner = 'WinnerS1',
  Contest2024Winner = 'WinnerS2',
  Contest2025Winner = 'WinnerS3',
  Contest2026Winner = 'WinnerS4',
}

export const ContestWinnerKeywords = [
  DirittoKeyword.Contest2023Winner,
  DirittoKeyword.Contest2024Winner,
  DirittoKeyword.Contest2025Winner,
  DirittoKeyword.Contest2026Winner,
];

export const MIN_CONTENT_SEARCH_LENGTH = 2;
